import { PasErrorCode, WweErrorCode } from '@ddt-web/error-handler';
import { PasPortfolioPosition } from '@ddt-web/pas';
import { WwePortfolioPosition } from '@ddt-web/wealth-web';
import { createAction, props } from '@ngrx/store';

export const positionDetailsLoaded = createAction(
	'[Data Loading] Position Details Data Loaded',
	props<{ payload: PasPortfolioPosition[] | WwePortfolioPosition[] }>()
);

export const taxDetailsLoaded = createAction(
	'[Data Loading] Tax Details Data Loaded',
	props<{ payload: PasPortfolioPosition[] | WwePortfolioPosition[] }>()
);

export const positionDetailsCompareLoaded = createAction(
	'[Data Loading] Position Details Compare Data Loaded',
	props<{ payload: PasPortfolioPosition[] | WwePortfolioPosition[] }>()
);

export const triggeredPositionPerHolding = createAction(
	'[Data Loading] Position Details Per Holding Data Triggered',
	props<{ payload: PasPortfolioPosition[] | WwePortfolioPosition[] }>()
);

export const triggeredTaxPerHolding = createAction(
	'[Data Loading] Tax Details Per Holding Data Triggered',
	props<{ payload: PasPortfolioPosition[] | WwePortfolioPosition[] }>()
);

export const triggeredPositionPerHoldingCompare = createAction(
	'[Data Loading] Position Details Per Holding Compare Data Triggered',
	props<{ payload: PasPortfolioPosition[] | WwePortfolioPosition[] }>()
);

export const partialSecurityFailing = createAction(
	'[Data Loading] Position Details Partial Security Failing',
	props<{ payload: Map<string, WweErrorCode | PasErrorCode> }>()
);
